module.exports = __webpack_public_path__ + "media/images/project_finder-938f3fa318f59246d25e1f64f0afc43f.jpeg";